import View from "components/layout/view";
import { parse } from "lib/locale";
import { useList } from "stores/hooks/list";
import { useLocale } from "stores/hooks/locale";
import UsersTable from "./users-table";
import { useEffect, useState } from "react";
import { ListUser } from "models/list-user";
import { ListEntity } from "models/list-entity";
import { sharedDoGetListUsers } from "services/shared/list-user";
import { sharedDoGetListEntities } from "services/shared/list-entity";
import Panel from "components/layout/panel";
import Header from "../header";
import Footer from "../footer";

const SharedListView = () => {
  const locale = useLocale();
  const list = useList();
  const [users, toggleUsers] = useState<ListUser[]>([]);
  const [listEntities, toggleListEntities] = useState<ListEntity[]>([]);

  const updateUsers = async () => {
    if (list) {
      const users = await sharedDoGetListUsers(list);
      toggleUsers(users);
    }
  };

  const updateEntities = async () => {
    if (list) {
      const entities = await sharedDoGetListEntities(list);
      toggleListEntities(entities);
    }
  };

  useEffect(() => {
    updateUsers();
    updateEntities();
  }, [list?.uuid]);

  if (!list) {
    return null;
  }

  const title = parse(list.name, locale);

  const { shared_noindex = false } = list;

  return (
    <View title={title} navigation={false} noindex={shared_noindex}>
      <Panel>
        <Header title={title} />
        <UsersTable users={users} listEntities={listEntities} />
      </Panel>
      <Footer />
    </View>
  );
};

export default SharedListView;
